/* eslint-disable */
export const translationKeys = {
  "AvanoTable": {
    "Settings": {
      "Title": "AvanoTable.Settings.Title",
      "ResetButtonLabel": "AvanoTable.Settings.ResetButtonLabel",
      "Pagination": {
        "ItemsPerPageLabel": "AvanoTable.Settings.Pagination.ItemsPerPageLabel"
      },
      "Columns": {
        "Label": "AvanoTable.Settings.Columns.Label"
      }
    },
    "DefaultButtons": {
      "Export": "AvanoTable.DefaultButtons.Export",
      "Refresh": "AvanoTable.DefaultButtons.Refresh",
      "Settings": "AvanoTable.DefaultButtons.Settings"
    },
    "Footer": {
      "Pagination": {
        "PageCountWithTotalTemplate": "AvanoTable.Footer.Pagination.PageCountWithTotalTemplate"
      }
    },
    "TableHeader": {
      "ResetAllFilters": "AvanoTable.TableHeader.ResetAllFilters"
    }
  },
  "unsavedChangesDialogComponent": {
    "btn": {
      "discard": "unsavedChangesDialogComponent.btn.discard",
      "cancel": "unsavedChangesDialogComponent.btn.cancel",
      "resume": "unsavedChangesDialogComponent.btn.resume",
      "save": "unsavedChangesDialogComponent.btn.save"
    },
    "msg": {
      "canSave": {
        "contentTitle": "unsavedChangesDialogComponent.msg.canSave.contentTitle",
        "contentMessage": "unsavedChangesDialogComponent.msg.canSave.contentMessage"
      },
      "noSave": {
        "contentTitle": "unsavedChangesDialogComponent.msg.noSave.contentTitle",
        "contentMessage": "unsavedChangesDialogComponent.msg.noSave.contentMessage"
      },
      "header": "unsavedChangesDialogComponent.msg.header",
      "applyToAll": "unsavedChangesDialogComponent.msg.applyToAll"
    }
  },
  "avano": {
    "errorsDetails": {
      "msg": {
        "header": "avano.errorsDetails.msg.header"
      },
      "btn": {
        "goTo": "avano.errorsDetails.btn.goTo"
      }
    },
    "notifications": {
      "btn": {
        "download": "avano.notifications.btn.download",
        "showAll": "avano.notifications.btn.showAll",
        "showDetails": "avano.notifications.btn.showDetails",
        "unread": "avano.notifications.btn.unread"
      },
      "msg": {
        "header": "avano.notifications.msg.header"
      }
    }
  },
  "tabsComponent": {
    "html": {
      "tab": {
        "loading": "tabsComponent.html.tab.loading"
      }
    }
  }
};
